import {defaultSelectedSeguimiento} from './state';

export function setHallazgo(state, hallazgo) {
  state.selectedSeguimiento.id_hallazgo = hallazgo.id;
  state.selectedSeguimiento.id_empresa = hallazgo.id_empresa;
}

export function setSeguimiento(state, seguimiento) {
  state.selectedSeguimiento = seguimiento;
}

export function setListaChequeo(state, id) {
  state.id_lista_chequeo = id;
}

export function setAccion(state, accion) {
  state.accion = accion;
}

export function setMostrarSeguimiento(state, hallazgo) {
  state.filtro.id_hallazgo = hallazgo.id_hallazgo;
}

export function setMostrarSeg(state, hallazgo) {
  state.filtro.id_empresa = hallazgo;
}

export function accionError(state) {
  state.error = true;
}

export function setPage(state, page) {
  state.filtro.page = page;
}

export function setListaAdjuntos(state, adjunto) {
  state.adjuntos = adjunto;
}

export function setAdjuntos(state, seguimiento) {
  state.imagenSeguimiento.id_empresa = state.filtro.id_empresa;
  state.imagenSeguimiento.id_seguimiento = seguimiento.id;
}

export function resetSelectedSeguimiento(state) {
  state.selectedSeguimiento.fecha_seguimiento = '';
  state.selectedSeguimiento.fecha_cierre = '';
  state.selectedSeguimiento.observacion = '';
  state.selectedSeguimiento.porc_implementacion = '';
  state.selectedSeguimiento.responsable = '';
  state.selectedSeguimiento.estado = '';
  //Object.assign(state.selectedSeguimiento, defaultSelectedSeguimiento())
}
